import { z } from 'zod';

import {
    error,
    MaterialFormDataSchema,
    StopFormDataValidationSchema,
} from '#components/order/CreateOrderDialog/OrderFormValidation.ts';
import { composeDateTimeValue } from '#components/order/CreateOrderDialog/timeWindowFields.ts';

export const ImportedOrderFormDataSchema = z.object({
    number: z.string().min(1, error.SMALL_STRING).max(255, error.LONG_STRING),
    customerName: z.string().max(255, error.LONG_STRING),
    loadingComment: z.string().max(1000, error.LONG_STRING).optional(),
    unloadingComment: z.string().max(1000, error.LONG_STRING).optional(),
    loadingStop: StopFormDataValidationSchema,
    unloadingStop: StopFormDataValidationSchema,
    materials: z.array(MaterialFormDataSchema),
});
export type ImportedOrder = z.infer<typeof ImportedOrderFormDataSchema>;

export const ImportOrderFormWizard = ImportedOrderFormDataSchema.refine(
    schema => {
        const pickupDateTime = composeDateTimeValue(schema.loadingStop.endDate, schema.loadingStop.endTime);
        const deliveryDateTime = composeDateTimeValue(schema.unloadingStop.endDate, schema.unloadingStop.endTime);

        if (pickupDateTime && deliveryDateTime) {
            const pickupDate = new Date(pickupDateTime);
            const deliveryDate = new Date(deliveryDateTime);
            return deliveryDate >= pickupDate;
        }
        return true;
    },
    {
        message: error.DATE_ORDER,
        path: ['unloadingStop', 'endDate'],
    }
).refine(
    data => {
        const pickupDateTime = composeDateTimeValue(data.loadingStop.startDate, data.loadingStop.startTime);
        const deliveryDateTime = composeDateTimeValue(data.unloadingStop.startDate, data.unloadingStop.startTime);

        if (pickupDateTime && deliveryDateTime) {
            const pickupDate = new Date(pickupDateTime);
            const deliveryDate = new Date(deliveryDateTime);
            return deliveryDate >= pickupDate;
        }
        return true;
    },
    {
        message: error.DATE_ORDER,
        path: ['unloadingStop', 'startDate'],
    }
);

export const ImportOrderFormDataSchema = z.object({
    orders: ImportOrderFormWizard.array(),
});

export type ImportOrderFormData = z.infer<typeof ImportOrderFormDataSchema>;
